import React, { useEffect, useRef, useState } from "react"
import { useAppSelector } from "../../core/store"
import {Form, useNavigate} from 'react-router'
import { AUTHED_ROUTES, ROUTES } from "../../routes/constants"
import { Button, Checkbox, Container, Flex, Heading, ScrollArea, Select, Text, TextArea, TextField } from "@radix-ui/themes"
import { ArchiveIcon, ArrowRightIcon, ColorWheelIcon, CrossCircledIcon, FilePlusIcon, FileTextIcon, GlobeIcon, MagnifyingGlassIcon, PaperPlaneIcon, PersonIcon, PlusIcon, ReaderIcon, ReloadIcon, RotateCounterClockwiseIcon, Share2Icon, StarFilledIcon, TrashIcon, UpdateIcon, UploadIcon } from "@radix-ui/react-icons"
import BaseModal from "../../components/controls/modals/BaseModal"
import { IUser } from "../../core/types/services-types/user-types"
import UserCardRender from "../../components/common/renders/user-card-render"
import useFetch from "../../core/hooks/useFetch"
import UserService from "../../core/services/UserService"
import TransactionService from '../../core/services/TransactionService'
import AdminService from '../../core/services/AdminService'
import {ToastContainer, toast} from 'react-toastify'
import { ITransaction } from "../../core/types/services-types/transaction-types"
import { ISettings } from "../../core/types/services-types/admin-types"
import { OtpInput, OtpInputHandle } from 'reactjs-otp-input';
import FileInput from '../../components/controls/inputs/FIleInput'
import { FileArray } from "./create-post"
import {ICompoundSubjectRights, ISubjectRights} from '../../core/types/services-types/subject-rights-types'
import SubjectRightsService from '../../core/services/SubjectRightsService'
export default function MainAdmin() {
    const user = useAppSelector(state => state.user)
    const navigate = useNavigate()

   
    const [nameUser, setNameUser] = useState<string>('')
    const [users, setUsers] = useState<IUser[]>([])
    const refScrollAreaUsers = useRef<HTMLDivElement>(null)
    const [limitUsers, setLimitUsers] = useState(100)
    const [pageUsers, setPageUsers] = useState(0)
    const [selectedUserForSendMoneys, setSelectedUserForSendMoneys] = useState<IUser | null>()
    const [selectedUserDelete, setSelectedUserDelete] = useState<IUser | null>(null)
    const [amount, setAmount] = useState<string>('')
    const [message, setMessage] = useState<string>('')
    const [mfa, setMfa] = useState<string>('')
    const [transaction, setTransaction] = useState<ITransaction>()
    const [openMoneysDialog, setOpenMoneysDialog] = useState<boolean>(false)
    const [openSiteNameDialog, setOpenSiteNameDialog] = useState<boolean>(false)
    const [openChangeFaviconIcoDialog, setOpenChangeFaviconIcoDialog] = useState<boolean>(false)
    const [openChangeMainImageDialog, setOpenChangeMainImageDialog] = useState<boolean>(false)
    const [openChangeContractJoiningService, setOpenChangeContractJoiningService] = useState<boolean>(false)
    const [openChangeBillDocumentTemplate, setOpenChangeBillDocumentTemplate] = useState<boolean>(false)
    const [openUploadPDFFileDialog, setOpenUploadPDFFileDialog] = useState<boolean>(false)
    const [openDeleteUserDialog, setOpenDeleteUserDialog] = useState<boolean>(false)
    const [settingsSite, setSettingsSite] = useState<ISettings>()
    const refOtp = useRef<OtpInputHandle>(null)
    const [fee, setFee] = useState<string>('')
    const [splittedPay, setSplittedPay] = useState<boolean>(false)
    const [nameSiteCurrency, setNameSiteCurrency] = useState('')
    const [nameSite, setNameSite] = useState<string>('')
    const [favicon, setFavicon] = useState<FileArray | null>()
    const [backgroundImage, setBackgroundImage] = useState<FileArray | null>()
    const [pdfFile, setPDFFile] = useState<FileArray | null>()
    const [templateBillDocument, setTemplateBillDocument] = useState<FileArray | null>()
    const [subjectRights, setSubjectRights] = useState<ISubjectRights[]>([])
    const [compoundSubjectRights, setCompoundSubjectRights] = useState<ICompoundSubjectRights[]>([])
    const [currentSubjectRights, setCurrentSubjectRights] = useState<string | number>()
    const [currentCompoundSubjectRights, setCurrentCompoundSubjectRights] = useState<string | number>()
    const [limitSubjectRights, setLimitSubjectRights] = useState<number>(100)
    const [pageSubjectRights, setPageSubjectRights] = useState<number>(0)
     

    const onClickUser = async (user: IUser) => {
        await fetchSubjectRights()
        setSelectedUserForSendMoneys(user)
    }


    const [fetchChangeFavicon, isLoadingChangeFavicon, errorChangeFavicon, errorsChangeFavicon] = useFetch(async () => {
        const formData = new FormData()
        if(favicon?.file) {
        formData.append('favicon-ico', favicon?.file)
        await AdminService.ChangeFaviconIco(formData)
        toast.success("Иконка сайта успешно изменена!")
        setOpenChangeFaviconIcoDialog(false)
        }
        else {
            toast.error("Выбериет иконку!")
        }
    })

    const [fetchChangeBackgroundImage, isLoadingChangeBackgroundImage, errorChangeBackgroundImage, errorsChangeBackgroundImage] = useFetch(async () => {
        const formData = new FormData()
        if(backgroundImage?.file) {
        formData.append('background-image', backgroundImage?.file)
        await AdminService.ChangeBackgroundImage(formData)
        toast.success("Задний фон главной успешно изменен!")
        setOpenChangeMainImageDialog(false)
        }
        else {
            toast.error("Выберите фото для заднего фона!")
        }
    })

    const [fetchChangeBillTemplate, isLoadingChangeBillTemplate, errorChangeBillTemplate, errorsChangeBillTemplate] = useFetch(async () => {
        const formData = new FormData()
        if(templateBillDocument?.file) {
        formData.append('template', templateBillDocument?.file)
        await AdminService.ChangeBillDocument(formData)
        toast.success("Шаблон счета успешно изменен!")
        setOpenChangeMainImageDialog(false)
        }
        else {
            toast.error("Выберите шаблон счета!")
        }
    })

    
          const handleFaviconFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = event.target.files
            if(files) {
                const file = files[0]
                if(file) {
                    setFavicon({
                        id: Date.now(),
                        name: file.name,
                        url: URL.createObjectURL(file),
                        file
                    })
                }
            }
    
          }
    
          const handleFaviconFileChangeDrop = (event: React.DragEvent<HTMLLabelElement>) => {
            event.preventDefault()
            console.log('2332')
            const files = event.dataTransfer.files
            const file = files[0]
            if(file) {
                setFavicon({
                    id: Date.now(),
                    name: file.name,
                    url: URL.createObjectURL(file),
                    file
                })
            }
          }


          const handleBackgroundFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = event.target.files
            if(files) {
                const file = files[0]
                if(file) {
                    setBackgroundImage({
                        id: Date.now(),
                        name: file.name,
                        url: URL.createObjectURL(file),
                        file
                    })
                }
            }
    
          }
    
          const handleBackgroundFileChangeDrop = (event: React.DragEvent<HTMLLabelElement>) => {
            event.preventDefault()
            console.log('2332')
            const files = event.dataTransfer.files
            const file = files[0]
            if(file) {
                setBackgroundImage({
                    id: Date.now(),
                    name: file.name,
                    url: URL.createObjectURL(file),
                    file
                })
            }
        }

            const handleContractJoiningServiceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = event.target.files
            if(files) {
                const file = files[0]
                if(file) {
                    setPDFFile({
                        id: Date.now(),
                        name: file.name,
                        url: URL.createObjectURL(file),
                        file
                    })
                }
            }
    
          }
    
          const handleContractJoiningServiceChangeDrop = (event: React.DragEvent<HTMLLabelElement>) => {
            event.preventDefault()
            console.log('2332')
            const files = event.dataTransfer.files
            const file = files[0]
            if(file) {
                setPDFFile({
                    id: Date.now(),
                    name: file.name,
                    url: URL.createObjectURL(file),
                    file
                })
            }
        }

            const handleBillDocumentTemplateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = event.target.files
            if(files) {
                const file = files[0]
                if(file) {
                    setTemplateBillDocument({
                        id: Date.now(),
                        name: file.name,
                        url: URL.createObjectURL(file),
                        file
                    })
                }
            }
    
          }
    
          const handleBillDocumentTemplateChangeDrop = (event: React.DragEvent<HTMLLabelElement>) => {
            event.preventDefault()
            console.log('2332')
            const files = event.dataTransfer.files
            const file = files[0]
            if(file) {
                setTemplateBillDocument({
                    id: Date.now(),
                    name: file.name,
                    url: URL.createObjectURL(file),
                    file
                })
            }
        }




    const [fetchUsers, isLoading, error, errors] = useFetch(async () => {
        const data = await UserService.GetUserForLoginMatch(nameUser, limitUsers, pageUsers)
        if(data.users.length) setUsers(data.users)
    })

    const [fetchSendMoneys, isLoadingFetchSendMoneys, errorFetchSendMoneys, errorsFetchSendMoneys] = useFetch(async () => {
        if(selectedUserForSendMoneys && amount && message && currentCompoundSubjectRights) {
        const data = await TransactionService.SendCurrencySiteToUserRequest(amount, message, selectedUserForSendMoneys.id, currentCompoundSubjectRights, splittedPay)
        setTransaction(data.transaction)
        toast.success(data.message)
    }
    })

    const [fetchSendMoneysFinish, isLoadingFetchSendMoneysFinish, errorFetchSendMoneysFinish, errorsFetchSendMoneysFinish] = useFetch(async () => {
        if(transaction) {
        const data = await TransactionService.SendCurrencySiteToUserFinish(transaction.id, mfa)
        setSelectedUserForSendMoneys(null)
        setTransaction(undefined)
        setAmount('')
        setMfa('')
        toast.success(data.message)
        setOpenMoneysDialog(false)
        }
    })

    const [fetchSendNewCode, isLoadingSendNewCode, errorFetchSendNewCode, errorsFetchSendNewCode] = useFetch(async () => {
        if(transaction) {
        const data = await TransactionService.RequestNewCodeForSendCurrencySiteToUser(transaction.id)
        toast.success(data.message)
        }
    })

    const [fetchChangeSite, isLoadingChangeSite, errorFetchChangeSite, errorsFetchChangeSite] = useFetch(async () => {
        const data = await AdminService.ChangeSettingsSite(fee, nameSiteCurrency, nameSite)
        setOpenSiteNameDialog(false)
        toast.success(data.message)
    })

    const [fetchSettingsSite, isLoadingSettingsSite, errorFetchSettingsSite, errorsFetchSettingsSite] = useFetch(async () => {
        const data = await AdminService.GetSettingsSite()
        setSettingsSite(data)
        setFee(data.fee)
        setNameSiteCurrency(data.name_site_currency)
        setNameSite(data.name_site)
    })

    const [fetchChangeContractJoiningService, isLoadingFetchChangeContractJoiningService, errorFetchChangeContractJoiningService, errorsFetchChangeContractJoiningService] = useFetch(async () => {
        if(pdfFile) {
        const formData = new FormData()
        formData.append('pdf', pdfFile?.file)
        const data = await AdminService.ChangeContractJoiningService(formData)
        toast.success("Договор для присоединения успешно изменен!")
        setOpenChangeMainImageDialog(false)
        }
    })

    const [fetchSubjectRights, isLoadingFetchSubjectRights, errorFetchSubjectRights, errorsFetchSubjectRights] = useFetch(async () => {
        const data = await SubjectRightsService.GetAll(limitSubjectRights, pageSubjectRights)
        setSubjectRights(data)
        setCurrentSubjectRights(data[0].id)
        setCompoundSubjectRights(data[0].compound_subject_rights)
        setCurrentCompoundSubjectRights(data[0].compound_subject_rights[0].id)
    })

    const [fetchDeleteUser, isLoadingFetchDeleteUser, errorDeleteUser, errorsDeleteUser] = useFetch(async (id: number) => {
        const data = await AdminService.DeleteUser(id)
        setUsers(prev => prev.filter(user => user.id === id))
    })

    



    const actionsUserCard = (user: IUser) => {
        return (
        <Flex align={'center'} gap={'3'}> 
        <Button onClick={() => navigate(`/profile/${user.id}`)}>
            <PersonIcon />
        </Button>

         <Button onClick={() => navigate(`/chats?chat_id=${user.id}`)}>
         <PaperPlaneIcon />
     </Button>

     <Button onClick={async () => await onClickUser(user)}>
         <Share2Icon />
     </Button>
    {!user.kyc_verifyed &&  <Button onClick={() => {setSelectedUserDelete(user); setOpenMoneysDialog(false); setOpenDeleteUserDialog(true);}}>
        <TrashIcon />
     </Button>}
     

     </Flex>
    )
    }


    const renderDescriptionMoneysDialog =  (
        <Container>
        <Text size={'4'} weight={'bold'}>Выберите пользователя</Text>
        <TextField.Root value={nameUser} onChange={e => setNameUser(e.target.value)} placeholder="Найти пользователя">
            <TextField.Slot>
                <MagnifyingGlassIcon />
            </TextField.Slot>
        </TextField.Root>
        { !selectedUserForSendMoneys ?
        <ScrollArea type="always" ref={refScrollAreaUsers} scrollbars="vertical" style={{height: '400px'}}>
            {users ? users.map(user => <UserCardRender key={user.id} user={user} actions={actionsUserCard} onClick={() => console.log('323')} />) : ''}
        </ScrollArea>
        :
        transaction ? 
        <Container className="mb-3">
        <Text weight={'bold'}>
            Введите код с почты
        </Text>
        <OtpInput
       value={mfa}
       onChange={setMfa}
       numInputs={6}
       className="border h-[50px] w-[40px] rounded-[10px]"
       containerStyle={{display: 'flex', gap: '5px', alignItems: 'center'}}
       inputStyle={{height: '45px', width: '35px', borderRadius: '10px'}}
       ref={refOtp}
        />
    <Container className="mt-3 mb-3">
        <Button variant='ghost' onClick={async () => await fetchSendNewCode()} loading={isLoadingSendNewCode}>Отправить еще раз</Button>
    </Container>
    <Button color="grass" onClick={async () => await fetchSendMoneysFinish()} loading={isLoadingFetchSendMoneysFinish}>Подтвердить</Button>
    </Container>
    :
        <Container className="mt-3"> 
        <Text>
            Выбранный пользователь
        </Text>
        <Flex align={'center'} justify={'between'} wrap={'wrap'} gap={'2'}> 
        <Container> 
        <UserCardRender user={selectedUserForSendMoneys} onClick={() => navigate(`/profile/${selectedUserForSendMoneys.id}`)} />
        </Container>
        <Button color="red" onClick={() => setSelectedUserForSendMoneys(null)}>
            <CrossCircledIcon />
        </Button>

        </Flex>
        <Container className="mt-5 mb-3">
            <Text>Введите количество Рассвет</Text>
            <TextField.Root placeholder="1000" type="number" value={amount} onChange={e => setAmount(e.target.value)}>

            </TextField.Root>
        </Container>

         <Container className="mt-5 mb-3">
            <Flex direction={'column'}> 
            <Text>Выберите Субъект права</Text>
                    <Select.Root 
                           size='3' 
                           defaultValue=""
                           onValueChange={e => setCurrentSubjectRights(e)}
                           value={`${currentSubjectRights}`}
                           >
                    <Select.Trigger />
                    <Select.Content>
                        {subjectRights.map(item => {
                            return <Select.Item key={item.id} value={`${item.id}`}>{item.name}</Select.Item>
                        })}
                    </Select.Content>
                </Select.Root>
                </Flex>
        </Container>

         <Container className="mt-5 mb-3">
            <Flex direction={'column'}> 
            <Text>Введите Состав Субъекта права</Text>
                    <Select.Root 
                           size='3' 
                           defaultValue=""
                           onValueChange={e => setCurrentCompoundSubjectRights(e)}
                           value={`${currentCompoundSubjectRights}`}
                           >
                    <Select.Trigger />
                    <Select.Content>
                            {compoundSubjectRights.map(item => {
                            return <Select.Item key={item.id} value={`${item.id}`}>{item.name}</Select.Item>
                        })}
                    </Select.Content>
                </Select.Root>
                {currentCompoundSubjectRights ? <Text>Дата: {compoundSubjectRights.find(item => item.id == currentCompoundSubjectRights)?.date}</Text> : '...'}
                </Flex>
        </Container>

         <Container className="mt-5 mb-3">
          <Text as="label" size="2">
	<Flex gap="2">
		<Checkbox checked={splittedPay} onCheckedChange={e => setSplittedPay(e as boolean)} />
		Разделенный платеж
	</Flex>
</Text>
        </Container>

         <Container className="mb-3">
            <Text>Сообщение</Text>
            <TextArea rows={7} maxLength={500} placeholder="Привет, хочу вернуть долг" value={message} onChange={e => setMessage(e.target.value)}></TextArea>
            {message.length}/500
        </Container>

            <Button onClick={async () => await fetchSendMoneys()} loading={isLoadingFetchSendMoneys}>Далее <ArrowRightIcon /> </Button>
            
        </Container>
        }
    </Container>
    )



    const renderDescriptionChangeSiteNameDialog = (
        <Container className="change-settings-site">
        <Container className="mb-5">
        <Text>
            Текущая комиссия %
        </Text>
        <TextField.Root placeholder="10%" type="number" value={fee} onChange={e => setFee(e.target.value)}>

        </TextField.Root>
        </Container>
        <Container className="mb-5">
        <Text>
            Название валюты сайта
        </Text>
        <TextField.Root placeholder="Рассвет" value={nameSiteCurrency} onChange={e => setNameSiteCurrency(e.target.value)}>

        </TextField.Root>
        </Container>
        <Container className="mb-5">
        <Text>
            Название сайта
        </Text>
        <TextField.Root placeholder="Рассвет..." value={nameSite} onChange={e => setNameSite(e.target.value)}>

        </TextField.Root>
        </Container>

        <Button color="grass" loading={isLoadingChangeSite} onClick={async () => await fetchChangeSite()}><UpdateIcon /> Применить</Button>
    </Container>
    )


    const renderDescriptionChangeSiteFaviconIcoDialog = (
        <Container className="change-settings-site">
            
            <Text>
                Выберите новую иконку
            </Text>
            <FileInput 
            classNamelabel="w-[100%] h-[200px] mb-5"
            classNameContainer="max-w-[200px]"
            handleDrop={handleFaviconFileChangeDrop}
            onChange={handleFaviconFileChange}
            />

            <Container className="mb-5">
                <img src={favicon?.url} />
            </Container>

            <Button color="grass" onClick={async () => await fetchChangeFavicon()} loading={isLoadingChangeFavicon}>
              <UploadIcon />  Изменить
            </Button>
        </Container>
    )


    const renderDescriptionChangeSiteBackgroundMainImageDialog = (
        <Container className="change-settings-site">
          <Text>
                Выберите новый фон на главной
            </Text>

            <FileInput 
            classNamelabel="w-[100%] h-[200px] mb-5"
            classNameContainer="max-w-[200px]"
            handleDrop={handleBackgroundFileChangeDrop}
            onChange={handleBackgroundFileChange}
            />

            <Container className="mb-5">
                <img src={backgroundImage?.url} />
            </Container>

            <Button color="grass" onClick={async () => await fetchChangeBackgroundImage()} loading={isLoadingChangeBackgroundImage}>
              <UploadIcon />  Изменить
            </Button>

        </Container>
    )

    const renderDescriptionChangeContractJoiningService = (
            <Container className="change-settings-site">
          <Text>
                Загрузите новый договор для присоединения
            </Text>

            <FileInput 
            classNamelabel="w-[100%] h-[200px] mb-5"
            classNameContainer="max-w-[200px]"
            handleDrop={handleContractJoiningServiceChangeDrop}
            onChange={handleContractJoiningServiceChange}
            contentLabel={<Text>📑 Загрузите файл pdf*</Text>}
            accept="application/pdf,"
            />

            <Container className="mb-5">
                {
                pdfFile ? 
               '📑' + pdfFile?.name
               :
               ''
                }
            </Container>

            <Button color="grass" onClick={async () => await fetchChangeContractJoiningService()} loading={isLoadingFetchChangeContractJoiningService}>
              <UploadIcon />  Изменить
            </Button>

        </Container>
    )


     const renderDescriptionChangeBillDocumentTemplate = (
            <Container className="change-settings-site">
          <Text>
                Загрузите новый шаблон документа счета
            </Text>

            <FileInput 
            classNamelabel="w-[100%] h-[200px] mb-5"
            classNameContainer="max-w-[200px]"
            handleDrop={handleBillDocumentTemplateChangeDrop}
            onChange={handleBillDocumentTemplateChange}
            contentLabel={<Text>📑 Загрузите файл docx*</Text>}
            accept="application/docx,"
            />

            <Container className="mb-5">
                {
                templateBillDocument ? 
               '📑' + templateBillDocument?.name
               :
               ''
                }
            </Container>

            <Button color="grass" onClick={async () => await fetchChangeBillTemplate()} loading={isLoadingChangeBillTemplate}>
              <UploadIcon />  Изменить
            </Button>

        </Container>
    )

    const renderDeleteUserDialog = (
        
        <Container className="delete-user-dialog">
            {
                !selectedUserDelete ? <Text color="red">Пользователь не выбран!</Text> :
                <Flex direction={'column'} align={'center'}>
                    <Text color="red" size={'4'}>После удаления пользователя ничего восстановить не получится!</Text>
                    <Text>ID пользователя: {selectedUserDelete.id}</Text>
                    <Text>Имя пользователя: {selectedUserDelete.login}</Text>
                    <Button color="red" onClick={async () => {await fetchDeleteUser(selectedUserDelete.id); setOpenDeleteUserDialog(false);}} loading={isLoadingFetchDeleteUser}>Удалить пользователя</Button>
                </Flex>
            }
        </Container>
        
    )

    useEffect(() => {
        if(currentSubjectRights) {
            const find = subjectRights.find(item => item.id === Number(currentSubjectRights))?.compound_subject_rights
            if(find) {
            setCompoundSubjectRights(find)
            setCurrentCompoundSubjectRights(find[0].id)
            }
        }
    }, [currentSubjectRights])

    useEffect(() => {
        console.log(user)
        if(user.user) { 
            if(user.user.role !== 'admin') {
        navigate(AUTHED_ROUTES.ACCOUNT_ROUTE)
            }
            if(user.user.role === 'operator') {
                navigate(AUTHED_ROUTES.REGISTRY_ROUTE)
            }
        }
        
    }, [user.user])


    useEffect(() => {
        if(refOtp.current) refOtp.current.focusInput = (index: number) => 0
    } , [refOtp.current])

    useEffect(() => {
        if(error.length) {
            toast.error(error)
        }
    }, [error])

    useEffect(() => {
        if(errorFetchSendMoneys.length) {
            toast.error(errorFetchSendMoneys)
        }
    }, [errorFetchSendMoneys])

    useEffect(() => {
        if(errorFetchSendMoneysFinish.length) {
            toast.error(errorFetchSendMoneysFinish)
        }
    }, [errorFetchSendMoneysFinish])

    useEffect(() => {
        if(errorFetchSendNewCode.length) {
            toast.error(errorFetchSendNewCode)
        }
    }, [errorFetchSendNewCode])

    useEffect(() => {
        if(errorFetchChangeSite.length) {
            toast.error(errorFetchChangeSite)
        }
    }, [errorFetchChangeSite])

    useEffect(() => {
        if(errorChangeBackgroundImage) {
            toast.error(errorChangeBackgroundImage)
        }
    }, [errorChangeBackgroundImage])

    useEffect(() => {
        if(errorChangeFavicon) {
            toast.error(errorChangeFavicon)
        }
    }, [errorChangeFavicon])

    useEffect(() => {
        if (errorChangeBillTemplate) {
            toast.error(errorChangeBillTemplate)
        }
    }, [errorChangeBillTemplate])

    useEffect(() => {
        if(errorDeleteUser) {
            toast.error(errorDeleteUser)
        }
    }, [errorDeleteUser])

    useEffect(() => {
        if(!openMoneysDialog) {
            setTransaction(undefined)
            setSelectedUserForSendMoneys(null)
            setMfa('')
            setAmount('')
        }
    }, [openMoneysDialog])

    useEffect(() => {
        fetchSettingsSite()
    }, [])

    useEffect(() => {
        fetchUsers()
    }, [nameUser])
    return (
        <Container className="p-5 pt-10 bg-zinc-100 h-[100vh]">
            <Container className="heading-admin mb-10 shadow-lg p-5 rounded-lg bg-zinc-50"> 
            <Heading>
                Админ панель
            </Heading>
            </Container>
            <ToastContainer />
            <Container className="shadow-xl p-10 rounded-lg bg-zinc-50">
            <Container className="heading-admin-functions mb-6"> 
                <Heading size={'4'} color='blue'>
                 <Flex align={'center'} gap={'1'}> <StarFilledIcon width={'30px'} height={'30px'} /> <Text size={'6'}>Функции</Text> </Flex> 
                </Heading>
                </Container>
            <Flex wrap={'wrap'} gap={'9'} align={'center'} justify={'center'}>
            <Flex direction={'column'}>
                <Flex direction={'column'} gap={'5'} maxWidth={'300px'}> 
                <BaseModal 
                showButton={<Button className="!p-5"><PersonIcon />Действия с пользователями</Button>}
                title="Действия с пользователями"
                description={renderDescriptionMoneysDialog}
                cancelButton={<Button color="red">Отмена</Button>}
                successButton={<></>}
                open={openMoneysDialog}
                onOpenChange={setOpenMoneysDialog}
            />
                <BaseModal 
                showButton={<Button className="!p-5"><GlobeIcon/>Действия с сайтом</Button>}
                title="Изменить настройки сайта"
                description={renderDescriptionChangeSiteNameDialog}
                cancelButton={<Button color="red">Отмена</Button>}
                successButton={<></>}
                open={openSiteNameDialog}
                onOpenChange={setOpenSiteNameDialog}
            />
            <BaseModal 
            showButton={<></>}
            title="Удаление пользователя и всех его данных"
            description={renderDeleteUserDialog}
            cancelButton={<Button color="red">Отмена</Button>}
            successButton={<></>}
            open={openDeleteUserDialog}
            onOpenChange={setOpenDeleteUserDialog}
            />
                <Button className="shadow-lg !p-5" variant="solid" onClick={() => navigate(AUTHED_ROUTES.CREATE_POST_ROUTE)}>
                   <PlusIcon /> Создать новость
                </Button>
                <Button className="shadow-lg !p-5" variant="solid" onClick={() => navigate(AUTHED_ROUTES.SUBJECT_RIGHTS)}>
                   <ArchiveIcon /> Субъекты права
                </Button>
                 <Button className="shadow-lg !p-5" variant="solid" onClick={() => navigate(AUTHED_ROUTES.REGISTRY_ROUTE)}>
                   <ArchiveIcon /> Регистры
                </Button>
                </Flex>
            </Flex>
            {user.user.role === 'admin' && 
            <Flex direction={'column'} gap={'5'}>

                <BaseModal 
                showButton={<Button className="shadow-lg !p-5"><RotateCounterClockwiseIcon />Изменить иконку сайта</Button>}
                title="Изменить иконку сайта"
                description={renderDescriptionChangeSiteFaviconIcoDialog}
                cancelButton={<Button color="red" onClick={() => setFavicon(null)}>Отмена</Button>}
                successButton={<></>}
                open={openChangeFaviconIcoDialog}
                onOpenChange={setOpenChangeFaviconIcoDialog}
                />


                <BaseModal 
                showButton={<Button className="shadow-lg !p-5"><ColorWheelIcon />Изменить фон на главной сайта</Button>}
                title="Изменить фон на главной сайта"
                description={renderDescriptionChangeSiteBackgroundMainImageDialog}
                cancelButton={<Button color="red" onClick={() => setBackgroundImage(null)}>Отмена</Button>}
                successButton={<></>}
                open={openChangeMainImageDialog}
                onOpenChange={setOpenChangeMainImageDialog}
                />

                <BaseModal 
                showButton={<Button className="shadow-lg !p-5"><ReaderIcon />Изменить договор для присоединения</Button>}
                title="Изменить договор для присоединения"
                description={renderDescriptionChangeContractJoiningService}
                cancelButton={<Button color="red" onClick={() => setBackgroundImage(null)}>Отмена</Button>}
                successButton={<></>}
                open={openChangeContractJoiningService}
                onOpenChange={setOpenChangeContractJoiningService}
                />

                <BaseModal 
                showButton={<Button className="shadow-lg !p-5"><ReaderIcon />ЗАЯВЛЕНИЕ-ТРЕБОВАНИЕ</Button>}
                title="ЗАЯВЛЕНИЕ-ТРЕБОВАНИЕ"
                description={renderDescriptionChangeBillDocumentTemplate}
                cancelButton={<Button color="red" onClick={() => setBackgroundImage(null)}>Отмена</Button>}
                successButton={<></>}
                open={openChangeBillDocumentTemplate}
                onOpenChange={setOpenChangeBillDocumentTemplate}
                />


                <Button className="shadow-lg !p-5" onClick={() => navigate('/admin/uploaded-documents')}> 
                  <FileTextIcon />  Загруженные пользователями документы
                </Button>

                <Button className="shadow-lg !p-5" onClick={() => navigate('/admin/all-bills')}> 
                  <FileTextIcon />  Заявления-требования пользователей
                </Button>

            </Flex>
            }
            </Flex>
            </Container>
        </Container>
    )
}